(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import i18nInstance from "../configs/i18n";
import { useDispatch, useSelector } from "../../../store";
import { setLanguage } from "../state/actions";
import { languageSelector } from "../state/selectors";
import { clearHsCodeDetails } from "../../Search/state/actions";
const languages = [{
  displayName: "English",
  name: "en"
}, {
  displayName: "Arabic",
  name: "ar"
}, {
  displayName: "Armenian",
  name: "am"
}];

const useLoadLanguage = lng => {
  const dispatch = useDispatch();
  const language = useSelector(languageSelector);
  const isLngValid = useMemo(() => languages.some(l => l.name === lng), [lng]);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (isLngValid && language !== lng) {
      i18nInstance.changeLanguage(lng);
      dispatch(setLanguage(lng));
      dispatch(clearHsCodeDetails());
    }
  }, [location, navigate, isLngValid, lng, dispatch, language]);
};

__signature__(useLoadLanguage, "useDispatch{dispatch}\nuseSelector{language}\nuseMemo{isLngValid}\nuseLocation{location}\nuseNavigate{navigate}\nuseEffect{}", () => [useDispatch, useSelector, useLocation, useNavigate]);

const _default = useLoadLanguage;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(languages, "languages", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Translation/hooks/useLoadLanguage.js");
  reactHotLoader.register(useLoadLanguage, "useLoadLanguage", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Translation/hooks/useLoadLanguage.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Translation/hooks/useLoadLanguage.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();